import { render, staticRenderFns } from "./video-player.vue?vue&type=template&id=5c730838&"
import script from "./video-player.vue?vue&type=script&lang=js&"
export * from "./video-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports